<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 个人中心 > 个人信息
			</div>
			<div class="contentLeft">


				<div class="con">
					<div class="left" ref="left" >
						<div class="tab-container tab">
							<ul>
								<li v-for="(item, index) in tabList" :key="index"
									:class="{ active: currentTabIndex == index }" @click="goOther(index)">
									{{ item }}
								</li>
							</ul>
						</div>
						<div class="tit">个人信息</div>
						<div class="tab-con">
							<el-form :model="ruleForm" ref="ruleForm" :rules="fromRules" class="demo-ruleForm">
								<el-form-item label="用户名" prop="username">
									<el-input disabled v-model="ruleForm.username" placeholder="请输入2-20位用户名"></el-input>
								</el-form-item>
								<el-form-item label="所属机构" prop="hospitalName">
									<el-input disabled v-model="ruleForm.hospitalName" placeholder="请输入机构信息"></el-input>
								</el-form-item>
								<el-form-item label="所属科室" prop="departmentName">
									<el-input disabled v-model="ruleForm.departmentName" placeholder="请输入科室信息">
									</el-input>
								</el-form-item>
								<el-form-item label="真实姓名" prop="name">
									<el-input v-model="ruleForm.name" placeholder="请输入真实姓名"></el-input>
								</el-form-item>
								<el-form-item label="手机号" prop="phone" class="phoneItem">
									<el-input v-model="ruleForm.phone" placeholder="请输入手机号" disabled></el-input>
									<div class="button" @click="changePhone">更换手机号码</div>
								</el-form-item>
								<el-form-item prop="code" class="codeItem" v-show="showChangePhone">
									<el-input v-model="ruleForm.code" placeholder="请输入短信验证码"></el-input>
									<div class="button" @click="getCodeOld('ruleForm')"
										:style="{ color: registerCodeInfo.getCodeBtnColor }">
										<span>|</span>
										<span>{{ registerCodeInfo.getCodeText }}</span>
									</div>
								</el-form-item>

								<el-form-item label="新手机号码" prop="newPhone" class="phoneItem phoneItemNew"
									v-show="showNext">
									<el-input v-model="ruleForm.newPhone" placeholder="请输入新手机号"></el-input>
								</el-form-item>
								<el-form-item label="验证码" prop="newCode" class="codeItem codeItemTwo" v-show="showNext">
									<el-input v-model="ruleForm.newCode" placeholder="请输入短信验证码"></el-input>
									<div class="button buttonTwo" @click="getCodeNew('ruleForm')"
										:style="{ color: registerCodeInfoNew.getCodeBtnColor }">
										<span>|</span>
										<span>{{ registerCodeInfoNew.getCodeText }}</span>
									</div>
								</el-form-item>
								<div class="buttonNext">
									<div class="next" v-show="showChangePhone" @click="changePhoneNext('ruleForm')">
										下一步
									</div>
									<div class="next" v-show="showNext" @click="changeSubmit('ruleForm')">
										确认
									</div>
									<div class="cancle" @click="changePhoneCancel" v-show="showNext || showChangePhone">
										取消
									</div>
								</div>
								<el-form-item class="nameSex sex" label="性别" prop="gender">
									<ul>
										<li v-for="(item,index) in sexArr" :key="index" @click="sexChange(index)">
											<img :src="index == sexCunrentIndex?item.activeImages:item.images" />
										</li>
									</ul>
								</el-form-item>
								<el-form-item class="textCenter">
									<span class="back" @click="cancel">取消</span>
									<span class="register" @click="submitForm('ruleForm')">确定</span>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="right" :style="{'height':leftHeight + 'px'}">
						<div class="tit">用户信息</div>
						<div class="top">
							<div class="top-con">
								<img src="../../../static/images/touxiang.png" />
								<p class="name">{{loginInfo.username}}</p>
								<p>
									<span>机构：</span>
									<span>{{loginInfo.hospitalName?loginInfo.hospitalName:'暂无'}}</span>
								</p>
								<p>
									<span>科室：</span>
									<span>{{loginInfo.departmentName?loginInfo.departmentName:'暂无'}}</span>
								</p>
							</div>
						</div>
						<div class="bottom">
							<div class="info">最近登录信息</div>
							<div class="loginInfo">
								<span>登录时间</span>
								<span>{{loginInfo.loginTime}}</span>
							</div>
						</div>
					</div>

				</div>


			</div>
		</div>
	</div>
</template>

<script>
	import NProgress from "nprogress";
	export default {
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.loginPassword) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				ruleForm: {
					hospitalName: '',
					departmentName: '',
					username: '',
					name: '',
					gender: 0,
					loginTime: '',
					phone: "",
					code: "",
					newPhone: "", //新手机号
					codeNew: "", //新手机号的验证码
				},
				fromRules: {
					code: [{
						required: true,
						message: "请输入短信验证码",
						trigger: "blur",
					}, ],
					newPhone: [{
							required: true,
							validator: this.validatePhone,
							trigger: "blur",
						},
						{
							pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
							message: "请输入正确的手机号",
							trigger: "blur",
						},
					],
					newCode: [{
						required: true,
						message: "请输入短信验证码",
				  trigger: "blur",
					}, ],
				},
				sexArr: [{
						images: require('../../../static/images/mzy/man_1.png'),
						activeImages: require('../../../static/images/mzy/man_2.png'),
					},
					{
						images: require('../../../static/images/mzy/woman_1.png'),
						activeImages: require('../../../static/images/mzy/woman_2.png'),
					},
				],
				sexCunrentIndex: 0,
				currentTabIndex: 0,
				loginInfo: {},
				tabList: ["个人中心", "修改密码"],
				showChangePhone: false,
				registerCodeInfo: {
					holdTime: 60,
					getCodeText: "获取验证码",
					getCodeBtnColor: "#679ff6",
					getCodeisWaiting: true,
					codeTimer: null,
				},
				showNext: false,
				registerCodeInfoNew: {
					holdTime: 60,
					getCodeText: "获取验证码",
					getCodeBtnColor: "#679ff6",
					getCodeisWaiting: true,
					codeTimer: null,
				},
				editToken: "",
				leftHeight:0
			}
		},

		methods: {
			//路由切换
			goOther(index) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/personalCenter/personalCenter",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/personalCenter/modifyPassword",
					});
				}
			},
			//初始化数据
			initData() {
				this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				if (this.loginInfo.gender == null) {
					this.loginInfo.gender = 0;
				}
				this.sexCunrentIndex = this.loginInfo.gender;
				this.ruleForm = {
					hospitalName: this.loginInfo.hospitalName,
					departmentName: this.loginInfo.departmentName,
					username: this.loginInfo.username,
					name: this.loginInfo.name,
					gender: this.loginInfo.gender,
					loginTime: this.loginInfo.loginTime,
					phone: this.loginInfo.phone ? this.loginInfo.phone : "13515106853",
				}
				
			},
			//sex
			sexChange(index) {
				this.sexCunrentIndex = index;
				this.ruleForm.gender = index;
			},
			//取消
			cancel() {
				this.initData();
			},
			//确定
			submitForm() {
				this.$applicationJson('/business/user/edit', {
					hospitalName: this.ruleForm.hospitalName,
					departmentName: this.ruleForm.departmentName,
					name: this.ruleForm.name,
					gender: this.ruleForm.gender,
					username: this.ruleForm.username,
				}).then(
					res => {
						//console.log(res)
						if (res.data.code == 0) {
							localStorage.setItem("loginInfo", JSON.stringify(this.ruleForm));
							this.$message.success('修改成功');
							this.initData();

						} else {
							this.$message.error(res.data.msg);
						}
					}
				).catch(Error => {
					this.$message.error('网络异常');
				})
			},
			// 手机号验证规则
			validatePhone(rule, value, callback) {
				if (value === "") {
			  callback(new Error("请输入手机号码"));
				} else if (!/^1[3|4|5|7|8][0-9]{9}$/.test(value)) {
					callback(new Error("请输入正确的手机号码"));
				} else {
					callback();
				}
			},
			//更换手机号
			changePhone() {
				this.showChangePhone = true;
			},
			//获取旧手机号验证码
			getCodeOld(ruleForm) {
				if (this.registerCodeInfo.getCodeisWaiting == false) {
					return false;
				}
				this.$applicationJson("/business/user/sms", {
						phone: this.ruleForm.phone,
						type: 2,
					})
					.then((res) => {
						if (res.data.code == 200) {
							this.setTimer(this.registerCodeInfo);
							this.registerCodeInfo.getCodeisWaiting = false;
							this.$message({
								message: "验证码已发送",
								type: "success",
							});
							NProgress.done();
						} else {
							this.$message.error(res.data.msg);
							NProgress.done();
						}
					})
					.catch(() => {
						this.$message.error("网络异常");
					});
			},

			//获取新手机号验证码
			getCodeNew(ruleForm) {
				if (this.registerCodeInfoNew.getCodeisWaiting == false) {
					return false;
				}
				this.$refs[ruleForm].validateField("newPhone", (newphoneValid) => {
					if (newphoneValid) {
						this.getSmsNew();
					} else {
						return false;
					}
				});
			},
			//获取新手机号验证码
			getSmsNew() {
				this.$applicationJson("/business/user/sms", {
						phone: this.ruleForm.newPhone,
						type: 3,
					})
					.then((res) => {
						if (res.data.code == 200) {
							this.setTimer(this.registerCodeInfoNew);
							this.registerCodeInfoNew.getCodeisWaiting = false;
							this.$message({
								message: "验证码已发送",
								type: "success",
							});
							NProgress.done();
						} else {
							this.$message.error(res.data.msg);
							NProgress.done();
						}
					})
					.catch(() => {
						this.$message.error("网络异常");
					});
			},
			//计时器
			setTimer(registerCodeInfo) {
				registerCodeInfo.getCodeText = "重新获取(60)";
				registerCodeInfo.getCodeBtnColor = "#ccc";
				registerCodeInfo.codeTimer = setInterval(() => {
					if (registerCodeInfo.holdTime <= 0) {
						registerCodeInfo.getCodeisWaiting = true;
						registerCodeInfo.getCodeText = "获取验证码";
						registerCodeInfo.getCodeBtnColor = "#679ff6";
						clearInterval(registerCodeInfo.codeTimer); //清除该函数
						return; //返回前面
					}
					registerCodeInfo.getCodeText =
						"重新获取(" + registerCodeInfo.holdTime + ")";
					registerCodeInfo.holdTime--;
				}, 1000);
			},
			//下一步
			changePhoneNext(ruleForm) {
				this.$refs[ruleForm].validateField("code", (valid) => {
					console.log(valid)
					if (valid) {
						this.getEditToken();
						this.showNext = true;
						this.showChangePhone = false;
					} else {
						return false;
					}
				});
			},
			//取消更换手机号
			changePhoneCancel() {
				this.showNext = false;
				this.showChangePhone = false;
			},
			//获取editToken
			getEditToken() {
				this.$applicationJson("/business/user/edit/phone/old", {
					captcha: this.ruleForm.code,
					phone: this.ruleForm.phone,
				}).then((res) => {
					// console.log(res);
					if (res.data.code == 0) {
						this.editToken = res.data.data.editToken;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			},
			//修改新手机号
			changeSubmit(ruleForm) {
				this.$refs[ruleForm].validate((valid) => {

					if (valid) {
						this.$applicationJson("/business/user/edit/phone/new", {
							captcha: this.ruleForm.newCode,
							phone: this.ruleForm.newPhone,
							editToken: this.editToken,
						}).then((res) => {
							console.log(res);
							if (res.data.code == 0) {
								this.$message({
									message: "手机号修改成功",
									type: "success",
								});
								this.showChangePhone = false;
								this.showNext = false;
								this.ruleForm.phone = this.ruleForm.newPhone;
								localStorage.setItem("loginInfo", JSON.stringify(this.ruleForm));
								this.initData();
				  	} else {
								this.$message.error(res.data.msg);
							}
						});
					} else {
						return false;
					}
				});
			},
			handleResize(){
				this.leftHeight = this.$refs.left.offsetHeight;				
			}
		},
		created() {
			this.$nextTick(() => {
				this.initData();
				this.leftHeight = this.$refs.left.offsetHeight;		
				window.addEventListener('resize', this.handleResize);
			})
		},
		beforeUnmount() {
			window.removeEventListener("resize", this.handleResize)
		}
	}
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {

			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.con {
					width: 100%;
					height: calc(100% - 10px);
				}

				//background: #fff;
				.left {
					width: 65%;
					//margin:20px 30px;
					//margin-left: 1%;
					float: left;
					border: 1px solid #e5e5e5;
					border-radius: 8px;
					//height: calc(100%);
					background: #fff;
					

					.phoneItem {
						position: relative;
						cursor: pointer;

						&.phoneItemNew {
							:deep(.el-input__inner){
								width: 448px;
							}
							
						}

						.button {
							width: 120px;
							height: 38px;
							line-height: 38px;
							text-align: center;
							border-radius: 5px;
							background: #679ff6;
							color: #fff;
							position: absolute;
							bottom: 0;
							left: 280px;
							cursor: pointer;


						}
					}

					.codeItem {
						position: relative;
						margin-top: 20px;

						&.codeItemTwo {
							margin-top: 0;
						}

						:deep(.el-input__inner){
							width: 448px;
						}

						.button {
							position: absolute;
							top: 0;
							left: 175px;
							cursor: pointer;
							top: 5px;

							span {
								&:nth-child(1) {
									margin-right: 10px;
								}
							}
						}
					}

					.buttonNext {
						display: flex;
						margin-top: 20px;
						font-size: 14px;
						cursor: pointer;

						.next {
							width: 100px;
							height: 40px;
							border-radius: 5px;
							background: #679ff6;
							color: #fff;
							line-height: 40px;
							text-align: center;
							margin-right: 20px;
						}

						.cancle {
							width: 100px;
							height: 38px;
							border-radius: 5px;
							border: 1px solid #ccc;
							line-height: 38px;
							text-align: center;
						}
					}

					.tab-container {
						ul {
							margin-left: 20px;
							margin-top: 10px;
							height: auto;
						}
					}

					.tit {
						background: #f5f5f5;
						line-height: 48px;
						height: 48px;
						font-size: 18px;
						padding-left: 23px;
						width: calc(100% - 23px);
						color: rgba(76, 81, 89, 1);
						display: none;
					}

					.tab-con {
						float: left;
						overflow: hidden;
						width: calc(100% - 70px);
						margin: 30px 50px;
						@media screen and (min-width: 800px) and (max-width: 1200px) {
							margin: 0px 50px;
						}
						:deep(.el-form-item) {
							margin-bottom: 10px;
							display: block;

							.el-input__wrapper {
								display: inline-block;
								flex-grow: 0;
							}
							
							.el-input__inner {
								width: 250px !important;
							}
						}

						.nameSex {
							overflow: hidden;
							width: 100%;

							ul {
								float: left;

								li {
									float: left;
									cursor: pointer;

									img {
										float: left;
										width: 30px;
										margin-top: 3px;
										margin-right: 10px;
										margin-bottom: 20px;

									}
								}
							}

						}

						.sex {
							width: 44%;
						}

						.textCenter {
							text-align: center;
							width: 250px;
							margin: 0 auto;

							.back {
								float: none;
							}
						}
					}

					.back {
						display: inline-block;
						color: #fff;
						height: 40px;
						line-height: 40px;
						border-radius: 3px;
						padding: 0 20px;
						cursor: pointer;
						background: #fff;
						border: 1px solid #eee;
						color: #333;
						margin-right: 20px;
					}

					.register {
						padding: 0 20px;
						background: #679FF6;
					}
				}

				.right {
					width: 33%;
					float: right;
					border: 1px solid #e5e5e5;
					border-radius: 8px;
					height: calc(100%);
					background: #fff;

					.tit {
						background: #f5f5f5;
						line-height: 48px;
						height: 48px;
						font-size: 18px;
						padding-left: 23px;
						width: calc(100% - 23px);
						color: rgba(76, 81, 89, 1);
					}

					.top {
						width: 100%;

						.top-con {
							img {
								margin: 30px auto;
								width: 100px;
							}

							width: 100%;

							.name {
								text-align: center;
								color: #13171D;
								font-size: 36px;
								line-height: 54px;
							}

							p {
								line-height: 24px;
								width: 200px;
								margin: 0 auto;
								font-size: 16px;
								color: #4C5159;
								margin-top: 10px;
								overflow: hidden;

								span {
									display: inline-block;
									float: left;

									&:nth-child(1) {
										width: 60px;
										text-align: center;
									}

									&:nth-child(2) {
										width: 140px;
										white-space: nowrap;
										overflow: hidden;
										text-overflow: ellipsis;
									}
								}
							}
						}
					}

					.bottom {
						width: 100%;
						margin-top: 60px;

						.info {
							color: #4C5159;
							line-height: 46px;
							font-size: 18px;
							padding-left: 23px;
							background: #F7F7F7;
							margin-bottom: 20px;
						}

						.loginInfo {
							border-bottom: 1px solid #e5e5e5;
							height: 36px;
							line-height: 36px;
							margin: 0 23px;

							span {
								color: #4C5159;
								font-size: 14px;

								&:nth-child(1) {
									float: left;
								}

								&:nth-child(2) {
									float: right;
								}
							}
						}
					}
				}
			}
		}
	}
</style>
